import React, { Component } from 'react';
import { observer } from 'mobx-react';

import './BottomBtnView.less'
@observer
class BottomBtnView extends Component {

    constructor(prop) {
        super(prop);
        this.sureItem = { title: '退货', action: 'sure', chooseBox: false, style: {} };
    }

    //按钮点击事件
    clickAction = (item) => {
        this.props.clickAction && this.props.clickAction(item);
    }

    renderItem = () => {
        const { model, openChoose } = this.props;
        let renderItem = openChoose ?
            <div onClick={this.clickAction.bind(this, this.sureItem)}> 确定 </div>
            :
            model.map((item, i) => {
                return (
                    <div onClick={this.clickAction.bind(this, item)} key={i}>
                        {item.title}
                    </div>
                );
            })
        return renderItem;
    }

    render() {

        return (
            <div className='bottomBtnView'>
                {this.renderItem()}
            </div>
        );
    }
}
export default BottomBtnView;